export default {
  trackingActivity: {
    order: "Order",
    job: "Job",
    shipment: "Shipment",
    activityTracking: "Activity Tracking",
    search: "Search",
    orderNo: "Order No",
    companyTaxId: "Company Tax ID",
    customerName: "Customer Name",
    status: "Status",
    dateTime: "Date/Time",
    updateDatetime: "Update Date/Time",
    createDatetime: "Create Date/Time",
    createBy: "Create By",
    presetLine: "Preset Line",
    upstreamTracking: "Upstream Tracking",
    paymentChannel: "Payment Channel",
    orderPrice: "Order Price",
    paymentType: "Payment Type",
    targetPickUpDatetime: "Target Pick Up Date/Time",
    targetDeliveryDatetime: "Target Delivery Date/Time",
    actualMileage: "Actual Mileage",
    action: "Action",
    submit: "Submit",
    confirm: "Confirm",
    cancel: "Cancel",
    tracking: "Tracking",
    viewMap: "View Map",
    assignToDriver: "Assign to Driver",
    parentJob: "Parent Job",
    parentOrder: "Parent Order",
    phoneNumber: "Phone number",
    vehicleType: "Vehicle type",
    licensePlate: "License plate",
    temperature: "Temperature",
    temperatureType: "Temperature type",
    temperatureRange: "Temperature range",
    shipperName: "Shipper name",
    package: "Number of Package",
    packageboxes: "packages/boxes",
    volume: "Volume",
    quantity: "Number of Item/Package",
    weight: "Weight",
    cubicMeter: "Cubic Meter",
    pickUpDetail: "Pick Up Detail",
    cargoInformation: "Cargo Information",
    targetPickUpDate: "Target Pick Up Date",
    actualPickUpDate: "Actual Pick Up Date/Time",
    pickUpLocation: "Pick Up Location",
    deliveryDetail: "Delivery Detail",
    actualDeliveryDateTime: "Actual Delivery Date/Time",
    deliveryLocation: "Delivery Location",
    reassign: "Re-assign",
    damage: "Damage",
    lost: "Lost",
    // updateDriver: "Update driver",
    // updateDriverForTheShipment: "Update Driver for the Shipment",
    haventAssignedToDriver: "Haven't assigned to Driver",
    orderList: "Order list",
    jobList: "Job list",
    shipmentList: "Shipment list",
    actionBy: "Action by",
    actionByAdmin: "Action by Admin",
    actionByDriver: "Action by Driver",
    updateStatus: "Update Status",
    reassignShipment: "Re-Assign Shipment",
    reassignOrder: "Re-Assign Order",
    reassignJob: "Re-Assign Job",
    cancelShipment: "Cancel Shipment",
    cancelJob: "Cancel Job",
    cancelOrder: "Cancel Order",
    setOrderAsALost: "Set order as a lost",
    setJobAsALost: "Set job as a lost",
    setShipmentAsALost: "Set shipment as a lost",
    setShipmentAsADamage: "Set shipment as a damage",
    setOrderAsADamage: "Set order as a damage",
    setJobAsADamage: "Set job as a damage",
    jobNumber: "Job Number",
    noOfShipments: "No. of Shipments",
    bu: "BU",
    orderNumber: "Order Number",
    shipmentNumber: "Shipment Number",
    subcontractorTaxId: "Subcontractor Tax ID",
    subocontractorName: "Subcontractor Name",
    createDateTime: "Create Date / Time",
    areYouSureYouWantToCancelOrder: "Are you sure you want to cancel order",
    areYouSureYouWantToCancelJob: "Are you sure you want to cancel job",
    areYouSureYouWantToCancelShipment:
      "Are you sure you want to cancel shipment",
    areYouSureYouWantToUpdateDriverForTheShipment:
      "Are you sure you want to Update driver for the shipment",
    areYouSureYouWantToUpdateDriverForTheOrder:
      "Are you sure you want to Update driver for the order",
    areYouSureYouWantToUpdateDriverForTheJob:
      "Are you sure you want to Update driver for the job",
    areYouSureYouWantToReassignTheShipment:
      "Are you sure you want to Re-Assign the shipment",
    areYouSureYouWantToReassignTheOrder:
      "Are you sure you want to Re-Assign the order",
    areYouSureYouWantToReassignTheJob:
      "Are you sure you want to Re-Assign the job",
    areYouSureYouWantToSetOrderStatusAsLost:
      "Are you sure you want to Set order status as Lost",
    areYouSureYouWantToSetShipmentStatusAsLost:
      "Are you sure you want to Set shipment status as Lost",
    areYouSureYouWantToSetJobStatusAsLost:
      "Are you sure you want to Set job status as Lost",
    areYouSureYouWantToSetOrderStatusAsDamage:
      "Are you sure you want to Set order status as Damage",
    areYouSureYouWantToSetShipmentStatusAsDamage:
      "Are you sure you want to Set shipment status as Damage",
    areYouSureYouWantToSetJobStatusAsDamage:
      "Are you sure you want to Set job status as Damage",

    cannotChangeStatus: "Cannot change status",
    driverHaveBeenUpdated: "Driver have been updated",
    jobHaveBeenCancelled: "Job have been cancelled",
    shipmentHaveBeenCancelled: "Shipment have been cancelled",
    orderHaveBeenCancelled: "Order have been cancelled",
    orderHaveBeenReassigned: "Order have been re-assigned",
    jobHaveBeenReassigned: "Job have been re-assigned",
    shipmentHaveBeenReassigned: "Shipment have been re-assigned",
    jobHaveBeenSetAsALost: "Job have been set as a lost",
    shipmentHaveBeenSetAsALost: "Shipment have been set as a lost",
    orderHaveBeenSetAsALost: "Order have been set as a lost",
    jobHaveBeenSetAsADamage: "Job have been set as a damage",
    shipmentHaveBeenSetAsADamage: "Shipment have been set as a damage",
    orderHaveBeenSetAsADamage: "Order have been set as a damage",
    palletsboxs: "pallets/boxs",
    pieces: "pieces",
    cube: "Cube",
    kg: "kg",
    filter: "Filter",
    pickUpDateTime: "Pick Up Date / Time",
    deliveryDateTime: "Delivery Date / Time",
    total: "Total",
    startDateTime: "Start Date/ Time",
    endDateTime: "End Date/ Time",
    allStatus: "All Status",
    all: "All",
    resetFilter: "Reset filter",
    startDate: "Start Date",
    endDate: "End Date",
    reason: "Reason",
    remark: "Remark",
    noData: "No Data",
    viewAllPOD: "View All POD",
    allPOD: "All POD",
    pickUpPOD: "Pick Up POD",
    deliveryPOD: "Delivery POD",
    damagedPOD: "Damaged POD",
    lostPOD: "Lost POD",
    returnPOD: "Return POD",
    actualPickup: "Actual Pick Up",
    goodsTemperature: "Goods Temperature",
    pickupWeight: "Picked Up Weight",
    actualVolume: "Actual Volume",
    actualDelivery: "Actual Delivery",
    offSiteSignOff: "Off-site Sign-off",
    wrongAddress: "Wrong Address",
    inaccuratePosition: "Inaccurate Position",
    correctAddress: "Correct Address",
    currentStatus: "Current Status",
    actualProcessTime: "Actual process time",
    updateTime: "Update time",
    updateBy: "Update by",
    updateTo: "Update to",
    skipBy: "Skip by",
    detail: "Detail",
    skipped: "Skipped",
    enterDetailsToSetStatus: "Enter all of status’s detail to set status",
    arriveOriginDateTime: "Arrive Origin Date and Time",
    readyToLoadDateTime: "Ready To Load Date and Time",
    skipStatus: "Skip this status",
    loadingDateTime: "Loading Date and Time",
    onTheWayDateTime: "On The Way Date and Time",
    goodTemp: "Good Temperature (C)",
    enterTemp: "Enter Temperature",
    deliverWeight: "Deliver Weight",
    deliverWeightKg: "Deliver Weight (Kg)",
    enterDeliverWeight: "Enter Deliver Weight",
    actualNoOfPackage: "Actual Number of Package",
    enterActualNoOfPackage: "Enter Actual Number of Package",
    actualNoOfItemPerPackage: "Actual Number of Item/Package",
    enterActualNoOfItemPerPackage: "Enter Actual Number of Item/Package",
    pickedUpWeightKg: "Picked Up Weight (Kg)",
    enterPickedUpWeight: "Enter Picked Up Weight",
    actualVolumeCM: "Actual Volume (Cubic Meter)",
    enterActualVolume: "Enter Actual Volume",
    arrivalDestinationDateTime: "Arrival Destination Date and Time",
    readyToUnloadDateTime: "Ready To Unload Date and Time",
    unloadingDateTime: "Unloading Date and Time",
    deliverDateTime: "Deliver Date and Time",
    deliveredDateTime: "Delivered Date and Time",    
    fieldDateGreaterThanPrevious: "{x} must be greater than the previous step’s date and time",
    invalidFieldName: "Invalid {field}",
    damagedDateTime: "Damaged Date and Time",
    lostDateTime: "Lost Date and Time",
    pendingDeliveryFailDateTime: "Pending Delivery Fail Date and Time",
    destination: "Destination",
    optionAfterSetStatus: "Option after set status",
    setStatusName: "Set status to {name}",
    changeDestination: "Change Destination",
    pickupFailedDateTime: "Pick Up Failed Date and Time",
    reAssignDriver: "Reassign Driver",
    returnOnthewayDateTime: "Return Ontheway Date and Time",
    returnArriveDateTime: "Return Arrive Date and Time",
    returnUnloadingDateTime: "Return Unloading Date and Time",
    returnedDateTime: "Returned Date and Time",
    returnWeightKg: "Return Weight (Kg)",
    enterReturnWeight: "Enter Return Weight",
    shipmentReturnTemp: "Shipment Return Temperature (C)",
    sureUpdateStatus: "Are you sure you want to update shipment <b>{shipmentNo}</b>’s status",
    updateStatusSuccess: "Update status successfully",
    quitUpdateStatus: "Quit Update Status",
    sureQuitStatus: "Are you sure you want to quit Update Status? All Change you made will not be saved.",
    moreDetail: "More Detail",
    returnDetail: "Return Detail",
    actualReturn: "Actual Return",
    returnLocation: "Return Location",
    locationOnGoogleMap: "Location on Google Map",
    returnDateTime: "Target Return Date/Time", 
    actualReturnDateTime: "Actual Return Date/Time",
    trackingDetail: "Tracking Detail",
    statusDetail: "Status Detail",
    shipmentPickupTemperature: "Shipment Pickup Temperature",
    shipmentDeliverTemperature: "Shipment Deliver Temperature",
    shipmentReturnTemperature: "Shipment Return Temperature",
    enterPaymentChannel: "Enter Payment Channel",
    enterActualOrderPrice: "Enter Actual Order Price",
    enterActualCurrency: "Enter Actual Currency",
    viewAllCargoList: "View All Cargo List",
    cargoList: "Cargo List",
    job_document: "Job Documents",
    documentation: "Documentation",
    readiness_check: "Readiness Check",

    // ACTIVITY_TRACKING_ORDER_STATUSES
    order_created: "order_created",
    order_confirmed: "order_confirmed",
    order_processing: "order_processing",
    order_picking_up: "order_picking_up",
    order_ontheway: "order_ontheway",
    order_delivered: "order_delivered",
    order_delivery_failed: "order_delivery_failed",
    order_approved: "order_approved",
    order_cancelled: "order_cancelled",
    order_pickup_failed: "order_pickup_failed",
    order_pending_delivery_fail: "order_pending_delivery_fail",
    order_returned: "order_returned",
    order_damaged: "order_damaged",
    order_lost: "order_lost",

    // ACTIVITY_TRACKING_JOB_STATUSES
    job_created: "job_created",
    job_planned: "job_planned",
    job_accepted: "job_accepted",
    job_arrive_origin: "job_arrive_origin",
    job_picking_up: "job_picking_up",
    job_ontheway: "job_ontheway",
    job_arrive_destination: "job_arrive_destination",
    job_handing_over: "job_handing_over",
    job_delivered: "job_delivered",
    job_approved: "job_approved",
    job_cancelled: "job_cancelled",
    job_pickup_failed: "job_pickup_failed",
    job_pending_delivery_fail: "job_pending_delivery_fail",
    job_delivery_failed: "job_delivery_failed",
    job_approved_return: "job_approved_return",
    job_returned: "job_returned",
    job_damaged: "job_damaged",
    job_lost: "job_lost",

    // ACTIVITY_TRACKING_SHIPMENT_STATUSES
    shipment_created: "shipment_created",
    shipment_processing: "shipment_processing",
    shipment_dispatched: "shipment_dispatched",
    shipment_arrive_origin: "shipment_arrive_origin",
    shipment_ready_to_load: "shipment_ready_to_load",
    shipment_loading: "shipment_loading",
    shipment_ontheway: "shipment_ontheway",
    shipment_arrive_destination: "shipment_arrive_destination",
    shipment_ready_to_unload: "shipment_ready_to_unload",
    shipment_unloading: "shipment_unloading",
    shipment_delivered: "shipment_delivered",
    shipment_approved: "shipment_approved",
    shipment_cancelled: "shipment_cancelled",
    shipment_pickup_failed: "shipment_pickup_failed",
    shipment_pending_delivery_fail: "shipment_pending_delivery_fail",
    shipment_delivery_failed: "shipment_delivery_failed",
    shipment_approved_return: "shipment_approved_return",
    shipment_return_ontheway: "shipment_return_ontheway",
    shipment_return_arrive: "shipment_return_arrive",
    shipment_return_unloading: "shipment_return_unloading",
    shipment_returned: "shipment_returned",
    shipment_damaged: "shipment_damaged",
    shipment_lost: "shipment_lost",

    // Driver
    driver: "Driver",
    hide: "Hide",
    viewAll: "View All",
    job: "Job",

    //Driver Time
    driverTime: "Driving Time",
    durationHrs: "Duration (hrs.)",
    driverActionType: "Action Type",
    driverStartTime: "Start Time",
    driverEndTime: "End Time",
    driverActionTypeTravel: "Travel",
  },
};



// WEBPACK FOOTER //
// ./src/lang/en/pages/tracking-activity/trackingActivity.js